import { InternalAxiosRequestConfig } from 'axios';

export const authHeaderRequestInterceptor: (config: InternalAxiosRequestConfig) => InternalAxiosRequestConfig = (
  config
) => {
  if (config.userId == null) {
    return config;
  }

  config.headers.set('Authorization', `Internal ${config.userId}:web`);
  return config;
};
